import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('loginPage') || initialState;

export const selectLoginRejected = createSelector(selectState, (state) =>
  state.get('loginRejected')
);
